import { Type } from '@sinclair/typebox';
import { OrganisationWithStakeholdersSchema, SelectProjectSchema, StakeholderInputSchema, StakeholdersWithoutOrgIdSchema, UpdateProjectSchema, } from '../../domain/projects/index.js';
import { FortnoxUserModel, UserRole } from '../../fortnox-user-schema.js';
import { PermissionModel } from '../../permission-schema.js';
import { NullishType } from '../../standard-schema.js';
export const ListProjectSchema = Type.Object({
    id: Type.String(),
    fortnoxId: NullishType(Type.String()),
    name: Type.String(), // Projektnamn
    status: NullishType(Type.String()), // Projektstatus
    type: NullishType(Type.String()), // Projekttyp
    earnings: NullishType(Type.Number()), // Resultat
    earningsPercent: NullishType(Type.Number()), // Resultat procent
    sekPerM2: NullishType(Type.Number()), // Kr/m2
    sekPerM2Ata: NullishType(Type.Number()), // Kr/m2 ink. Äta
    compensationForm: NullishType(Type.String()), // Ersättningsform
    contractSum: NullishType(Type.Number()), // Kontraktsumma
    ataSum: NullishType(Type.Number()), // ÄTA-summa
    undertakingSum: NullishType(Type.Number()), // Entrepenadsumma
    startDate: NullishType(Type.String()), // Startdatum
    endDate: NullishType(Type.String()), // Slutdatum
    cash: NullishType(Type.Number()), // Kassa
    invoiced: NullishType(Type.Number()), // Fakturerat
    hasSupplierInvoicesToApprove: Type.Boolean(),
});
export const ListProjectsResponseSchema = Type.Array(ListProjectSchema);
const ProjectDetailsBaseSchema = Type.Pick(SelectProjectSchema, [
    'id',
    'fortnoxId',
    'name',
    'status',
    'type',
    'size',
    'compensationForm',
    'contractSum',
    'arvode',
    'startDate',
    'endDate',
    'notes',
    'douinDate',
    'samprovDate',
    'contractorType',
    'handoverDate',
    'fdobDate',
]);
export const ProjectDetailsSchema = Type.Intersect([
    ProjectDetailsBaseSchema,
    Type.Object({
        earnings: NullishType(Type.Number()), // Resultat
        earningsPercent: NullishType(Type.Number()), // Resultat procent
        ataSum: NullishType(Type.Number()), // ÄTA-summa
        undertakingSum: NullishType(Type.Number()), // Entreprenadsumma
    }),
]);
export const GetProjectDetailsResponseSchema = ProjectDetailsSchema;
export const GetProjectDetailsParamsSchema = Type.Object({
    id: Type.String(),
});
export const ListProjectNameSchema = Type.Object({
    id: Type.String(),
    fortnoxId: NullishType(Type.String()),
    name: Type.String(),
});
export const ListProjectNamesResponseSchema = Type.Array(ListProjectNameSchema);
export const ProjectNameResponseSchema = ListProjectNameSchema;
export const GetProjectParamsSchema = Type.Object({
    id: Type.String(),
});
export const GetProjectResponseSchema = Type.Object({
    id: Type.String(),
    fortnoxId: NullishType(Type.String()),
    name: Type.String(),
    status: NullishType(Type.String()),
    type: NullishType(Type.String()),
    size: NullishType(Type.Number()),
    compensationForm: NullishType(Type.String()),
    contractSum: NullishType(Type.Number()),
    startDate: NullishType(Type.String()),
    samprovDate: NullishType(Type.String()),
    douinDate: NullishType(Type.String()),
    endDate: NullishType(Type.String()),
    handoverDate: NullishType(Type.String()),
    fdobDate: NullishType(Type.String()),
    contractorType: NullishType(Type.String()),
    notes: NullishType(Type.String()),
});
export const UpdateProjectParamsSchema = Type.Object({
    id: Type.String(),
});
export const UpdateProjectBodySchema = UpdateProjectSchema;
export const GetProjectNotesParamsSchema = Type.Object({
    id: Type.String(),
});
export const GetProjectNotesSchema = Type.Object({
    notes: Type.Union([Type.String(), Type.Null()]),
});
export const PutProjectNotesParamsSchema = Type.Object({
    id: Type.String(),
});
export const PutProjectNotesSchema = Type.Object({
    notes: Type.Union([Type.String(), Type.Null()]),
});
export const PutProjectNotesResponseSchema = GetProjectNotesSchema;
// Project Users
export const GetProjectUsersParamsSchema = Type.Object({
    id: Type.String(),
});
const ProjectPermissionSchema = Type.Omit(PermissionModel, ['id', 'userId', 'projectId']);
export const GetProjectUsersResponseSchema = Type.Array(Type.Intersect([
    FortnoxUserModel,
    Type.Object({ permissions: Type.Array(ProjectPermissionSchema) }),
]));
export const GetProjectOrganisationResponseSchema = OrganisationWithStakeholdersSchema;
export const GetProjectOrganisationsResponseSchema = Type.Array(OrganisationWithStakeholdersSchema);
export const PutProjectOrganisationStakeholdersBodySchema = Type.Array(StakeholderInputSchema);
export const PutProjectOrganisationStakeholdersResponseSchema = Type.Array(StakeholdersWithoutOrgIdSchema);
// Project Eligible Reviewers
export const GetProjectReviewersParamsSchema = Type.Object({
    id: Type.String(),
});
export const GetProjectReviewersResponseSchema = Type.Array(Type.Object({
    id: Type.String(),
    name: Type.String(),
    email: Type.String(),
    role: Type.Enum(UserRole),
}));
export const GetDefaultReviewersResponseSchema = Type.Array(Type.Object({
    id: Type.String(),
    ranking: Type.Number(),
    name: Type.String(),
    email: Type.String(),
    role: Type.Enum(UserRole),
}));
